import { UsersStorage } from './users-storage';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, finalize, switchMap, tap } from 'rxjs/operators';
import { UserSearch } from './user-search';

@Component({
    selector: 'user-search-select',
    template: require('./user-search-select.component.html'),
    styles: [require('./user-search-select.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserSearchSelectComponent {
    @Input()
    public control: FormControl;

    public users$: Observable<UserSearch[]>;
    public readonly searchUserFlow$ = new Subject<string>();
    public readonly isSearchingForUsers$ = new BehaviorSubject(false);

    constructor(private userSearchService: UsersStorage) { }

    public ngOnInit() {
        this.users$ = this.searchUserFlow$.pipe(
            debounceTime(300),
            distinctUntilChanged(),
            tap(() => this.isSearchingForUsers$.next(true)),
            switchMap(searchTerm => this.userSearchService.search(searchTerm)),
            tap(() => this.isSearchingForUsers$.next(false)),
            finalize(() => this.isSearchingForUsers$.next(false))
        );
    }

    public onUsersChange(users: UserSearch[]) {
        this.control.setValue(users);
    }

}
